import { useMemo } from "react";
import { Controller } from "react-hook-form";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

export const RHFSelectField = ({
  name,
  label,
  options,
  optionIdentifiers,
  control,
  validationHelper,
  rules,
  viewMode,
  size,
}) => {
  const memoizedOptions = useMemo(() => options, [options]);
  const memoizedOptionIdentifiers = useMemo(
    () => optionIdentifiers,
    [optionIdentifiers],
  );

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <FormControl fullWidth error={!!error} disabled={viewMode} size={size}>
          <InputLabel id={`${name}-label`}>{label}</InputLabel>
          <Select
            labelId={`${name}-label`}
            {...field}
            value={field.value ?? ""}
            label={label}
            error={!!error}
          >
            {memoizedOptions?.map((option) => (
              <MenuItem
                key={option[memoizedOptionIdentifiers.id]}
                value={option[memoizedOptionIdentifiers.id]}
              >
                {option[memoizedOptionIdentifiers.label]}
              </MenuItem>
            ))}
          </Select>
          {error && (
            <FormHelperText>{validationHelper[name]?.required}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
};
